import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2e221c1c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=2e221c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e221c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e221c1c')) {
      api.createRecord('2e221c1c', component.options)
    } else {
      api.reload('2e221c1c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2e221c1c&scoped=true&", function () {
      api.rerender('2e221c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/filiale_scan_in/form/detail.vue"
export default component.exports